import { createAsyncThunk } from '@reduxjs/toolkit';
import { storeResources } from '../../resources';
import { createTicketFromTemplate } from '../../../services/ticketTemplates';

interface IProps {
  payload: any;
}

export const ThunkCreateTicketFromTemplate = createAsyncThunk<{ data: string }, IProps>(
  `${storeResources.TICKETS}/createTicketFromTemplate`,
  ({ payload }) => createTicketFromTemplate(payload).then(res => res.data),
);
